import BaseMapStyle from "@mapmycustomers/shared/enum/map/BaseMapStyle";

type MapTypeStyle = google.maps.MapTypeStyle;

const googleMapStyles: Readonly<Partial<Record<BaseMapStyle, MapTypeStyle[]>>> = {
  [BaseMapStyle.ASSASSIAN_CREED]: [
    {
      elementType: "all",
      featureType: "all",
      stylers: [{ visibility: "on" }],
    },
    {
      elementType: "labels",
      featureType: "all",
      stylers: [{ visibility: "off" }, { saturation: -100 }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "all",
      stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }, { visibility: "off" }],
    },
    {
      elementType: "labels.text.stroke",
      featureType: "all",
      stylers: [{ visibility: "off" }, { color: "#000000" }, { lightness: 16 }],
    },
    {
      elementType: "labels.icon",
      featureType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "geometry.fill",
      featureType: "administrative",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "administrative",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
    },
    {
      elementType: "geometry",
      featureType: "landscape",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "landscape",
      stylers: [{ color: "#4d6059" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "landscape",
      stylers: [{ color: "#4d6059" }],
    },
    {
      elementType: "geometry.fill",
      featureType: "landscape.natural",
      stylers: [{ color: "#4d6059" }],
    },
    {
      elementType: "geometry",
      featureType: "poi",
      stylers: [{ lightness: 21 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "poi",
      stylers: [{ color: "#4d6059" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "poi",
      stylers: [{ color: "#4d6059" }],
    },
    {
      elementType: "geometry",
      featureType: "road",
      stylers: [{ visibility: "on" }, { color: "#7f8d89" }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road",
      stylers: [{ color: "#7f8d89" }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.highway",
      stylers: [{ color: "#7f8d89" }, { lightness: 17 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.highway",
      stylers: [{ color: "#7f8d89" }, { lightness: 29 }, { weight: 0.2 }],
    },
    {
      elementType: "geometry",
      featureType: "road.arterial",
      stylers: [{ color: "#000000" }, { lightness: 18 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.arterial",
      stylers: [{ color: "#7f8d89" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.arterial",
      stylers: [{ color: "#7f8d89" }],
    },
    {
      elementType: "geometry",
      featureType: "road.local",
      stylers: [{ color: "#000000" }, { lightness: 16 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.local",
      stylers: [{ color: "#7f8d89" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.local",
      stylers: [{ color: "#7f8d89" }],
    },
    {
      elementType: "geometry",
      featureType: "transit",
      stylers: [{ color: "#000000" }, { lightness: 19 }],
    },
    {
      elementType: "all",
      featureType: "water",
      stylers: [{ color: "#2b3638" }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ color: "#2b3638" }, { lightness: 17 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "water",
      stylers: [{ color: "#24282b" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "water",
      stylers: [{ color: "#24282b" }],
    },
    {
      elementType: "labels",
      featureType: "water",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text",
      featureType: "water",
      stylers: [{ visibility: "off " }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "water",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text.stroke",
      featureType: "water",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.icon",
      featureType: "water",
      stylers: [{ visibility: "off" }],
    },
  ],
  [BaseMapStyle.GRAY]: [
    {
      elementType: "labels.text.fill",
      featureType: "all",
      stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
    },
    {
      elementType: "labels.text.stroke",
      featureType: "all",
      stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }],
    },
    {
      elementType: "labels.icon",
      featureType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "geometry.fill",
      featureType: "administrative",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "administrative",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
    },
    {
      elementType: "geometry",
      featureType: "landscape",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      elementType: "geometry",
      featureType: "poi",
      stylers: [{ color: "#000000" }, { lightness: 21 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.highway",
      stylers: [{ color: "#000000" }, { lightness: 17 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.highway",
      stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: 0.2 }],
    },
    {
      elementType: "geometry",
      featureType: "road.arterial",
      stylers: [{ color: "#000000" }, { lightness: 18 }],
    },
    {
      elementType: "geometry",
      featureType: "road.local",
      stylers: [{ color: "#000000" }, { lightness: 16 }],
    },
    {
      elementType: "geometry",
      featureType: "transit",
      stylers: [{ color: "#000000" }, { lightness: 19 }],
    },
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ color: "#000000" }, { lightness: 17 }],
    },
  ],
  [BaseMapStyle.HOPPER]: [
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ hue: "#165c64" }, { saturation: 34 }, { lightness: -69 }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "landscape",
      stylers: [{ hue: "#b7caaa" }, { saturation: -14 }, { lightness: -18 }, { visibility: "on" }],
    },
    {
      elementType: "all",
      featureType: "landscape.man_made",
      stylers: [{ hue: "#cbdac1" }, { saturation: -6 }, { lightness: -9 }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "road",
      stylers: [{ hue: "#8d9b83" }, { saturation: -89 }, { lightness: -12 }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "road.highway",
      stylers: [
        { hue: "#d4dad0" },
        { saturation: -88 },
        { lightness: 54 },
        { visibility: "simplified" },
      ],
    },
    {
      elementType: "geometry",
      featureType: "road.arterial",
      stylers: [
        { hue: "#bdc5b6" },
        { saturation: -89 },
        { lightness: -3 },
        { visibility: "simplified" },
      ],
    },
    {
      elementType: "geometry",
      featureType: "road.local",
      stylers: [{ hue: "#bdc5b6" }, { saturation: -89 }, { lightness: -26 }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "poi",
      stylers: [{ hue: "#c17118" }, { saturation: 61 }, { lightness: -45 }, { visibility: "on" }],
    },
    {
      elementType: "all",
      featureType: "poi.park",
      stylers: [{ hue: "#8ba975" }, { saturation: -46 }, { lightness: -28 }, { visibility: "on" }],
    },
    {
      elementType: "geometry",
      featureType: "transit",
      stylers: [
        { hue: "#a43218" },
        { saturation: 74 },
        { lightness: -51 },
        { visibility: "simplified" },
      ],
    },
    {
      elementType: "all",
      featureType: "administrative.province",
      stylers: [
        { hue: "#ffffff" },
        { saturation: 0 },
        { lightness: 100 },
        { visibility: "simplified" },
      ],
    },
    {
      elementType: "all",
      featureType: "administrative.neighborhood",
      stylers: [{ hue: "#ffffff" }, { saturation: 0 }, { lightness: 100 }, { visibility: "off" }],
    },
    {
      elementType: "labels",
      featureType: "administrative.locality",
      stylers: [{ hue: "#ffffff" }, { saturation: 0 }, { lightness: 100 }, { visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "administrative.land_parcel",
      stylers: [{ hue: "#ffffff" }, { saturation: 0 }, { lightness: 100 }, { visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "administrative",
      stylers: [{ hue: "#3a3935" }, { saturation: 5 }, { lightness: -57 }, { visibility: "off" }],
    },
    {
      elementType: "geometry",
      featureType: "poi.medical",
      stylers: [{ hue: "#cba923" }, { saturation: 50 }, { lightness: -46 }, { visibility: "on" }],
    },
  ],
  [BaseMapStyle.MIDNIGHT]: [
    {
      elementType: "labels.text.fill",
      featureType: "all",
      stylers: [{ color: "#ffffff" }],
    },
    {
      elementType: "labels.text.stroke",
      featureType: "all",
      stylers: [{ color: "#000000" }, { lightness: 13 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "administrative",
      stylers: [{ color: "#000000" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "administrative",
      stylers: [{ color: "#144b53" }, { lightness: 14 }, { weight: 1.4 }],
    },
    {
      elementType: "all",
      featureType: "landscape",
      stylers: [{ color: "#08304b" }],
    },
    {
      elementType: "geometry",
      featureType: "poi",
      stylers: [{ color: "#0c4152" }, { lightness: 5 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.highway",
      stylers: [{ color: "#000000" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.highway",
      stylers: [{ color: "#0b434f" }, { lightness: 25 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.arterial",
      stylers: [{ color: "#000000" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.arterial",
      stylers: [{ color: "#0b3d51" }, { lightness: 16 }],
    },
    {
      elementType: "geometry",
      featureType: "road.local",
      stylers: [{ color: "#000000" }],
    },
    {
      elementType: "all",
      featureType: "transit",
      stylers: [{ color: "#146474" }],
    },
    {
      elementType: "all",
      featureType: "water",
      stylers: [{ color: "#021019" }],
    },
  ],
  [BaseMapStyle.MUTED]: [
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
    },
    {
      elementType: "geometry",
      featureType: "landscape",
      stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "road.highway",
      stylers: [{ color: "#ffffff" }, { lightness: 17 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.highway",
      stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
    },
    {
      elementType: "geometry",
      featureType: "road.arterial",
      stylers: [{ color: "#ffffff" }, { lightness: 18 }],
    },
    {
      elementType: "geometry",
      featureType: "road.local",
      stylers: [{ color: "#ffffff" }, { lightness: 16 }],
    },
    {
      elementType: "geometry",
      featureType: "poi",
      stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
    },
    {
      elementType: "geometry",
      featureType: "poi.park",
      stylers: [{ color: "#dedede" }, { lightness: 21 }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
    },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    {
      elementType: "geometry",
      featureType: "transit",
      stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
    },
    {
      elementType: "geometry.fill",
      featureType: "administrative",
      stylers: [{ color: "#fefefe" }, { lightness: 20 }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "administrative",
      stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
    },
  ],
  [BaseMapStyle.NIGHT]: [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      elementType: "labels.text.fill",
      featureType: "administrative.locality",
      stylers: [{ color: "#d59563" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "poi",
      stylers: [{ color: "#d59563" }],
    },
    {
      elementType: "geometry",
      featureType: "poi.park",
      stylers: [{ color: "#263c3f" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "poi.park",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      elementType: "geometry",
      featureType: "road",
      stylers: [{ color: "#38414e" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road",
      stylers: [{ color: "#212a37" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "road",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      elementType: "geometry",
      featureType: "road.highway",
      stylers: [{ color: "#746855" }],
    },
    {
      elementType: "geometry.stroke",
      featureType: "road.highway",
      stylers: [{ color: "#1f2835" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "road.highway",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      elementType: "geometry",
      featureType: "transit",
      stylers: [{ color: "#2f3948" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "transit.station",
      stylers: [{ color: "#d59563" }],
    },
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ color: "#17263c" }],
    },
    {
      elementType: "labels.text.fill",
      featureType: "water",
      stylers: [{ color: "#515c6d" }],
    },
    {
      elementType: "labels.text.stroke",
      featureType: "water",
      stylers: [{ color: "#17263c" }],
    },
  ],
  [BaseMapStyle.STANDARD]: [
    {
      elementType: "labels.text",
      featureType: "poi.business",
      stylers: [{ visibility: "on" } /*, { color: "#333333" }*/],
    },
  ],
  [BaseMapStyle.SUBTLE_GRAY]: [
    {
      elementType: "all",
      featureType: "administrative",
      stylers: [{ saturation: -100 }],
    },
    {
      elementType: "all",
      featureType: "administrative.province",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "landscape",
      stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: "on" }],
    },
    {
      elementType: "all",
      featureType: "poi",
      stylers: [{ saturation: -100 }, { lightness: 50 }, { visibility: "simplified" }],
    },
    {
      elementType: "all",
      featureType: "road",
      stylers: [{ saturation: -100 }],
    },
    {
      elementType: "all",
      featureType: "road.highway",
      stylers: [{ visibility: "simplified" }],
    },
    {
      elementType: "all",
      featureType: "road.arterial",
      stylers: [{ lightness: 30 }],
    },
    {
      elementType: "all",
      featureType: "road.local",
      stylers: [{ lightness: 40 }],
    },
    {
      elementType: "all",
      featureType: "transit",
      stylers: [{ saturation: -100 }, { visibility: "simplified" }],
    },
    {
      elementType: "geometry",
      featureType: "water",
      stylers: [{ hue: "#ffff00" }, { lightness: -25 }, { saturation: -97 }],
    },
    {
      elementType: "labels",
      featureType: "water",
      stylers: [{ lightness: -25 }, { saturation: -100 }],
    },
  ],
  [BaseMapStyle.TRIPPITY]: [
    {
      elementType: "labels",
      featureType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "administrative",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "landscape",
      stylers: [{ color: "#2c5ca5" }],
    },
    {
      elementType: "all",
      featureType: "poi",
      stylers: [{ color: "#2c5ca5" }],
    },
    {
      elementType: "all",
      featureType: "road",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "transit",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "all",
      featureType: "water",
      stylers: [{ color: "#193a70" }, { visibility: "on" }],
    },
  ],
};

export default googleMapStyles;
